<template>
    <auth-box class="max-w-[480px]"
        :errors="props.errors">
        <form id="emergency-token-form"
            ref="formRef"
            data-test="emergency-token-form"
            method="POST"
            action="/login-via-emergency-token"
            class="flex flex-col gap-4"
            novalidate
            @submit.prevent="submit()">

            <vx-alert color="info">
                After logging in via your emergency token, <strong>two-factor authentication will be disabled for your account</strong>. If you would like to maintain two-factor authentication security, you should re-enable it after logging in.
            </vx-alert>

            <div>
                <vx-label>
                    Emergency Token
                </vx-label>
                <vx-input v-model="data.token"
                    required
                    type="password"
                    autofocus
                    name="token"
                    id="token"
                    size="lg"
                    data-test="emergency-token"
                    :error="displayFirstError(v$.token.$errors)">
                </vx-input>
            </div>

            <div class="flex flex-col gap-2 mt-4 md:flex-row-reverse">
                <vx-button :loading="submitting"
                    @click.prevent="submit()"
                    data-test="submit"
                    class="md:grow"
                    type="submit"
                    color="primary"
                    size="lg">
                    Log In <font-awesome-icon widthAuto :icon="faArrowRight"></font-awesome-icon>
                </vx-button>

                <vx-button color="muted"
                    size="lg"
                    href="/login">
                    Cancel
                </vx-button>
            </div>
        </form>
    </auth-box>
</template>
<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import AuthBox from '../AuthBox.vue';
import { VxInput, VxButton, VxAlert, VxLabel } from '@voxie/frontend-components';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { ref, reactive } from 'vue';
import useVuelidate from '@vuelidate/core';
import { helpers, required } from '@vuelidate/validators';
import { displayFirstError, validateRules } from '~/utils/validation';

const props = defineProps({
    errors: Array,
});

const formRef = ref(null);

const data = reactive({
    token: '',
});

const submitting = ref(false);

const v$ = useVuelidate({
    token: {
        required: helpers.withMessage('Emergency token is required', required),
        validEmergencyToken: helpers.withMessage(
            'Emergency token is invalid',
            helpers.regex(/^[A-Za-z0-9]{40}$/)
        ),
    },
}, data);

const submit = async () => {
    submitting.value = true;

    const isFormCorrect = await validateRules(v$);
    if (!isFormCorrect) {
        submitting.value = false;
        return;
    }

    formRef.value?.submit();
};
</script>
